'use client';
import {
  RubiesAmount,
  WebCoinAmount,
} from '@wwe-portal/ui/features/club-store';
import { useGetUserBalance } from '@wwe-portal/web/providers/queries/user-info';
import { CATEGORY_IDS } from '@wwe-portal/web/utils/constants/offer';
import { formatThousands } from '@wwe-portal/utils/format';
import { useRouter } from 'next/navigation';
export const UserBalance = () => {
  const router = useRouter();
  const { rubies, webCoins } = useGetUserBalance();
  const scrollToCategoryHandler = (category: string) => () => {
    router.push(`?category=${category}`);
  };
  if (rubies == null && webCoins == null) return null;
  return (
    <div className="flex justify-center gap-2 md:hidden">
      <RubiesAmount
        amount={formatThousands(rubies ?? 0)}
        onClickAdd={scrollToCategoryHandler(CATEGORY_IDS.RUBIES)}
      />
      <WebCoinAmount
        amount={formatThousands(webCoins ?? 0)}
        onClickAdd={scrollToCategoryHandler(CATEGORY_IDS.WEBCOINS)}
      />
    </div>
  );
};
